import Flicking from '@egjs/react-flicking'
import { motion } from 'framer-motion'
import React, { useRef, useState } from 'react'
import { useTranslations } from '../../hooks/useTranslations'
import Slider from '../molecules/Slider'

const M08BReferencesSliderNew = ({ heading, references, anchorLinkId }) => {
  const ref = useRef()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [imageX, setImageX] = useState(0)
  const [imageX2, setImageX2] = useState(0)
  const translations = useTranslations()

  const handleChange = index => {
    ref.current?.moveTo(index)
  }

  return (
    <section className="overflow-hidden" id={anchorLinkId}>
      <div className="container">
        <h2 className="mb-2 u-h1">{heading}</h2>

        <Slider
          count={references.length}
          index={currentIndex}
          onChange={handleChange}
        />

        <div className="sm:w-[90vw] lg:w-auto sm:ml-[calc(320px-45vw-42px)] md:ml-[calc(384px-45vw-54px)] lg:ml-0">
          <Flicking
            ref={ref}
            onWillChange={e => setCurrentIndex(e.index)}
            onMove={e => {
              setImageX(e.axesEvent.delta.flick * 2.5)
              setImageX2(e.axesEvent.delta.flick)
            }}
          >
            {references.map((reference, index) => {
              const images = [
                reference?.referenceDetails[0].photo1[0],
                reference?.referenceDetails[0].photo2[0],
              ]

              return (
                <div
                  className="w-full px-3 row-type-e md:px-7 lg:px-0"
                  key={reference?.title}
                >
                  <div className="col-1-type-e">
                    <div className="flex space-x-2 sm:block sm:space-x-0 pb-9 sm:pb-0">
                      {images.length > 0 && (
                        <motion.img
                          src={images[0].url}
                          alt=""
                          className="h-[145px] w-auto sm:w-9/12 sm:h-auto shadow-tpmp lg:shadow-dp rounded-[5px]"
                          animate={{ x: imageX }}
                          transition={{
                            type: 'spring',
                            stiffness: 150,
                            bounce: 0,
                            mass: 0.1,
                            velocity: 0,
                          }}
                        />
                      )}
                      {images.length > 1 && (
                        <div className="flex justify-end">
                          <motion.img
                            src={images[1].url}
                            alt=""
                            className="h-[145px] w-auto sm:-mt-16 sm:w-6/12 sm:h-auto -z-1 rounded-[5px]"
                            animate={{ x: imageX2 }}
                            transition={{
                              type: 'spring',
                              stiffness: 150,
                              bounce: 0,
                              mass: 0.1,
                              velocity: 0,
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-2-type-e">
                    <h3 className="mb-5 u-h2">
                      {reference?.referenceDetails[0].headline}
                    </h3>
                    <div className="pr-3 column-indent sm:pr-6 md:pr-6 lg:pr-0">
                      <div
                        className="u-p copy link-wrapper"
                        dangerouslySetInnerHTML={{
                          __html: reference?.referenceDetails[0].description,
                        }}
                      />
                      <div className="u-p-small max-w-[274px] divide-y divide-gray-4">
                        <div className="py-2">{reference?.title}</div>
                        {Object.entries(reference?.referenceAttributes[0])
                          .filter(([, v]) => v)
                          .map(([k, v]) => (
                            <div key={k} className="py-2">
                              {translations[k] ?? k}: {v}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Flicking>
        </div>
      </div>
    </section>
  )
}

export default M08BReferencesSliderNew
